import React from "react";
import moment from "moment";
import { FiArrowRight } from "react-icons/fi";
import { MdContentCopy } from "react-icons/md";

import TourBalloon from "components/NewTour/TourBallon";
import { copyTypeableLine } from "features/portal/services/clipboard";
import { invoiceLabels } from "features/portal/constants";

import {
  BodyBill,
  ButtonBills,
  ButtonCopy,
  ContainerWrap,
  ContentBill,
  DueDateBill,
  ExtraCard,
  FooterBill,
  HeaderCard,
  MonthYearBill,
  StatusCard,
  TitleCard,
  ValueBill,
} from "./PortalPage.styles";

type Props = {
  bill: any;
  showTour: boolean;
  tourStep: number;
  tourType: string;
};

const PortalBillPanel = ({
  bill,
  showTour,
  tourStep,
  tourType,
}: Props): JSX.Element => {
  const highlight = tourStep === 6 && tourType === "home" && showTour;

  return (
    <ContentBill showTour={highlight}>
      <ContainerWrap>
        <HeaderCard>
          <TitleCard>Fatura atual</TitleCard>
          {bill && (
            <ExtraCard>
              <StatusCard status={bill?.invoice?.status} />
              <span>{invoiceLabels[bill?.invoice?.status]}</span>
            </ExtraCard>
          )}
        </HeaderCard>
        <BodyBill>
          {bill ? (
            <>
              <MonthYearBill>
                <span>
                  {moment(`${bill?.invoice?.referenceMonth || ""}/01`)?.format(
                    "MMM"
                  )}
                </span>
                <span>
                  {moment(`${bill?.invoice?.referenceMonth || ""}/01`)?.format(
                    "yyyy"
                  )}
                </span>
              </MonthYearBill>
              <DueDateBill>
                <span>Vencimento</span>
                <span>
                  {moment(bill?.invoice?.dueDate ?? "")?.format("DD/MM/yyyy")}
                </span>
              </DueDateBill>
              <ValueBill>
                {Intl.NumberFormat("pt-br", {
                  style: "currency",
                  currency: "BRL",
                }).format(bill?.invoice?.totalAmount?.replace(",", "."))}
              </ValueBill>
            </>
          ) : (
            <span>Você não possui fatura atual!</span>
          )}
        </BodyBill>
        <FooterBill>
          {bill ? (
            <ButtonCopy
              onClick={() => copyTypeableLine(bill?.invoice?.typeableLine)}
            >
              <span>Copiar código</span>
              <MdContentCopy />
            </ButtonCopy>
          ) : (
            <div />
          )}
          <ButtonBills to="/consulta-debitos">
            <span>Histórico de boletos</span>
            <FiArrowRight />
          </ButtonBills>
        </FooterBill>
        {showTour && tourStep === 6 && tourType === "home" && (
          <TourBalloon
            title="Fatura atual"
            content="Aqui você encontra as informações da sua fatura atual. Ao clicar em Copiar código, de forma prática e rápida, você pode copiar os dados para pagamento do boleto."
            position={{
              left: "0",
              right: "0",
              top: "142px",
              arrowPosition: "top",
              maxWidth: 320,
              arrowTop: "-38px",
            }}
          />
        )}
      </ContainerWrap>
    </ContentBill>
  );
};

export default PortalBillPanel;
